<div class="codigos-verificacion-container">

    <div class="card search-card">
        <div class="card-body">

            <div class="mb-4">
                <h4 class="titulo mb-1">
                    Códigos de verificación
                </h4>

                <p class="descripcion mb-0">
                    Consulta y busca los códigos de verificación generados en la plataforma.
                </p>
            </div>

            <div class="form-row align-items-end">

                <div class="form-group col-md-9 mb-md-0">

                    <label for="filtro">
                        Buscar
                    </label>

                    <input
                        id="filtro"
                        type="text"
                        class="form-control"
                        [(ngModel)]="filtro"
                        placeholder="Buscar por RUT, nombre, correo, código, tipo..."
                        autocomplete="off"
                        [disabled]="cargando"
                        (input)="aplicarFiltro()">

                </div>

                <div class="form-group col-md-3 mb-0">

                    <div class="botones-busqueda">

                        <button
    type="button"
    class="btn btn-outline-secondary btn-limpiar"
    [disabled]="cargando || !filtro"
    (click)="limpiarBusqueda()">

    <svg
        class="icono-boton"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>

    Limpiar
</button>

                       <button
    type="button"
    class="btn btn-primary btn-actualizar"
    [disabled]="cargando"
    (click)="listarCodigos()">

    <span
        *ngIf="cargando"
        class="spinner-border spinner-border-sm mr-2"
        role="status">
    </span>

    <svg
        *ngIf="!cargando"
        class="icono-boton"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <polyline points="23 4 23 10 17 10"></polyline>
        <polyline points="1 20 1 14 7 14"></polyline>
        <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10"></path>
        <path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14"></path>
    </svg>

    Actualizar
</button>

                    </div>

                </div>

            </div>

            <div
                *ngIf="mensajeError"
                class="alert alert-danger mt-3 mb-0">

                {{ mensajeError }}

            </div>

        </div>
    </div>


    <div
        *ngIf="!cargando"
        class="resultado-header">

        <div>

            <h5 class="mb-1">
                Códigos generados
            </h5>

            <div class="datos-usuario">

                <span *ngIf="!filtro">
                    Mostrando todos los registros de las ultimas 24 horas.
                    Los codigos de verificación expiran a los 5 minutos de ser generados.
                </span>

                <span *ngIf="filtro">
                    Resultados para "{{ filtro }}"
                </span>

            </div>

        </div>

        <div class="cantidad-resultados">

            {{ codigosFiltrados.length }}

            {{
                codigosFiltrados.length === 1
                    ? 'registro'
                    : 'registros'
            }}

        </div>

    </div>


    <div
        *ngIf="!cargando && codigosFiltrados.length > 0"
        class="card tabla-card">

        <div class="table-responsive">

            <table class="table table-hover mb-0">

                <thead>
                    <tr>
                        <th>Fecha</th>
                        <th>RUT</th>
                        <th>Usuario</th>
                        <th>Correo</th>
                        <th>Tipo</th>
                        <th>Código</th>
                        <th>Estado</th>
                    </tr>
                </thead>

                <tbody>

                    <tr
                        *ngFor="
                            let codigo of codigosFiltrados;
                            trackBy: trackByCodigo
                        ">

                        <td class="fecha">
                            {{ codigo.ver_cod_date || '-' }}
                        </td>

                        <td>
                            {{ codigo.ver_cod_username || '-' }}
                        </td>

                        <td>

                            <div class="nombre-usuario">
                                {{
                                    obtenerNombreCompleto(codigo) || '-'
                                }}
                            </div>

                            <small class="text-muted">
                                ID: {{ codigo.ver_cod_use_id }}
                            </small>

                        </td>

                        <td>
                            {{ codigo.ver_cod_email || '-' }}
                        </td>

                        <td>

                            <span class="tipo-codigo">
                                {{ codigo.tipo_cod || '-' }}
                            </span>

                        </td>

                        <td>

                            <span class="codigo-verificacion">
                                {{ codigo.ver_cod_code || '-' }}
                            </span>

                        </td>

                        <td>

                            <div class="estado-container">

                                <span
                                    class="badge badge-estado"
                                    [ngClass]="{
                                        'badge-success':
                                            codigoActivo(codigo.ver_cod_date),

                                        'badge-secondary':
                                            !codigoActivo(codigo.ver_cod_date)
                                    }">

                                    {{
                                        obtenerEstadoCodigo(
                                            codigo.ver_cod_date
                                        )
                                    }}

                                </span>

                                <small
                                    *ngIf="
                                        codigoActivo(
                                            codigo.ver_cod_date
                                        )
                                    "
                                    class="tiempo-restante">

                                    Expira en
                                    {{
                                        obtenerTiempoRestante(
                                            codigo.ver_cod_date
                                        )
                                    }}

                                </small>

                            </div>

                        </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>


    <div
    *ngIf="
        !cargando &&
        codigosFiltrados.length === 0 &&
        !mensajeError
    "
    class="sin-resultados">

    <div class="sin-resultados-icono">

        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>

    </div>

    <h5>No se encontraron resultados</h5>

    <p *ngIf="filtro" class="mb-0">
        No existen registros que coincidan con "{{ filtro }}".
    </p>

    <p *ngIf="!filtro" class="mb-0">
        No existen códigos de verificación registrados.
    </p>

</div>


    <div
        *ngIf="cargando"
        class="cargando-container">

        <div
            class="spinner-border text-primary"
            role="status">

            <span class="sr-only">
                Cargando...
            </span>

        </div>

        <span class="ml-3">
            Cargando códigos de verificación...
        </span>

    </div>

</div>
